import { useState } from 'react';
import type { ErrorMessage } from '@theme/theme.d';
import axios from '@helpers/axios';

export const useRtmpKey = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ErrorMessage | null>(null);

  const getStatusKey = async (teamId: string) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/score_delegation_key/${teamId}`);
      return response.data;
    } catch (err) {
      setError({
        message: `Could not get status key. ${err}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const getRtmpKey = async (captureId: string) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/rtmp_key/${captureId}`);
      const { rtmp } = response.data;
      return rtmp;
    } catch (err) {
      setError({
        message: `Could not get RTMP key. ${err}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    getStatusKey,
    getRtmpKey,
    loading,
    error,
  };
};
